import React from 'react';
import {BackButton} from './style';
import { withRouter } from 'react-router-dom';

const Back = (props) => {
  return <BackButton>
    <a onClick={(!props.backTo) ? () => props.history.goBack() : () => props.history.replace(props.backTo)}>
      <i
        className="right-side-icon icon mapsa-left-arrow_1"
        title="بازگشت"
      />
      {(!props.noLabel) && <span>بازگشت</span>}
    </a>
	</BackButton>
};

export default withRouter(Back);